import './css/Carousel.css';
import { useMediaQuery } from 'react-responsive';
import YouTubeFacade from './components/YouTubeFacade';

const videoHeight = 450;

function HomeCarouselItem({videoUrl, description}){
    const isMobile = useMediaQuery({ query: `(max-width: 960px)` });
    return (
        <div className={isMobile ? "carousel-item-mobile" : "carousel-item"}>
            <YouTubeFacade
                videoId={videoUrl}
                title={description}
                height={videoHeight}
            />
            <br /><br />
            <div className="carousel-desc">
                <p>
                {description}
                </p>
            </div>
        </div>
    )
}

export default HomeCarouselItem;
